import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tooltip, Icon } from 'next/components/ui';
import { selectInstalledDomain } from 'next/entities/installed';
import { FlagWrapper, FlagTooltipText } from './styled';

const INSTALLED_LABEL = (
  <>
    <span>Installed and ready</span>
    <FlagTooltipText>
      Appcues has seen a user on this domain in the past year.
    </FlagTooltipText>
  </>
);

const NOT_INSTALLED_LABEL = (
  <>
    <span>Install not detected</span>
    <FlagTooltipText>
      Appcues has not seen a user on this domain in the past year. You can still
      select this domain if you anticipate volume soon.
    </FlagTooltipText>
  </>
);

export function DomainFlag({ installed, hostName }) {
  return (
    <FlagWrapper $installed={installed}>
      {hostName}
      <Tooltip
        size="m"
        wrapped
        label={installed ? INSTALLED_LABEL : NOT_INSTALLED_LABEL}
      >
        <Icon
          aria-label={`domain ${installed ? 'installed' : 'not installed'}`}
          icon="circle"
        />
      </Tooltip>
    </FlagWrapper>
  );
}

DomainFlag.propTypes = {
  installed: PropTypes.bool,
  hostName: PropTypes.string,
};

const mapStateToProps = (state, { hostName }) => ({
  installed: Boolean(selectInstalledDomain(state, hostName)),
});

export default connect(mapStateToProps)(DomainFlag);
